import apiNew from '../apiNew';

const fetchMachines = (params = {}) => {
  return apiNew.get(`/machines`, {
    params: {
      ...params,
    },
  });
};

const fetchMachinebyId = (id, params = {}) => {
  return apiNew.get(`/machines/${id}`, {
    params: {
      ...params,
    },
  });
};

const changeMachinesbyId = (id, body = {}) => {
  return apiNew.put(`/machines/${id}`, body);
};

const registerMachine = (body = {}) => {
  return apiNew.post(`/machines`, body);
};

const deleteMachine = (id) => {
  return apiNew.delete(`/machines/${id}`);
};

export {
  fetchMachines,
  fetchMachinebyId,
  changeMachinesbyId,
  registerMachine,
  deleteMachine,
};
